import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createEndorsementInfoSlice = (set, get) => ({
    endorsementDetails: {
        loading: false,
        comments: [],
        infos: {}
    },
    getEndorsementDetailsInfo: async (EndorsementId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ endorsementDetails: { ...state.endorsementDetails, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: `/v1/business/endorsement/${EndorsementId}/info`,
                headers: { token },
            });
            set(state => ({ endorsementDetails: { ...state.endorsementDetails, loading: false, infos: resp.data } }));
        } catch (error) {
            set(state => ({ endorsementDetails: { ...state.endorsementDetails, loading: false } }));
        }
    }
});
